import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ResetOrgModal from './ResetOrgModal'
import DevKeyModal from './DevKeyModal'
import NewContextModal from './NewContextModal'
import OrganizationDetails from './OrganizationDetails'
import { Link } from 'react-router-dom'
import { useStateValue } from '@State'

const OrgContainer = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  const [resetOrgModalOpen, toggleResetOrgModal] = useState(false)
  const [devKeyModalOpen, toggleDevKeyModal] = useState(false)
  const [newContextModalOpen, toggleContextModal] = useState(false)

  useEffect(() => {
    if (currentState.selectedOrg) {
      if (match.params.orgId !== currentState.selectedOrg.id) {
        dispatch({
          type: 'selectOrg',
          payload: null,
        })
      }
    }
  }, [])

  return (
    <Fragment>
      <div className="card-myed">
        <div className="pull-right">
          <Link
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4"
            to={`/account/admin_org_key_management/-/`}
          >
            <div className="fa-regular fa-arrow-circle-left fa-fw mr-2" /> Go Back
          </Link>
          <div
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4"
            onClick={() => toggleResetOrgModal(!resetOrgModalOpen)}
          >
            <div className="fa-regular fa-undo fa-fw mr-2" /> Reset
          </div>
          <div
            className="btn btn-warning btn-myed btn-warning-myed btn-sm-myed"
            onClick={() => toggleDevKeyModal(!devKeyModalOpen)}
          >
            <div className="fa-regular fa-key fa-fw mr-2" /> Dev Key
          </div>
          <div
            className="btn btn-myed btn-primary btn-primary-myed btn-sm-myed"
            onClick={() => toggleContextModal(!newContextModalOpen)}
          >
            <div className="fa-regular fa-plus fa-fw mr-2" /> Add New Context
          </div>
        </div>
        <h3>Organization Details</h3>
        <OrganizationDetails orgId={match.params.orgId} />
      </div>
      <ResetOrgModal
        orgId={match.params.orgId}
        show={resetOrgModalOpen}
        toggle={toggleResetOrgModal}
      />
      <DevKeyModal
        orgId={match.params.orgId}
        show={devKeyModalOpen}
        toggle={toggleDevKeyModal}
      />
      <NewContextModal
        orgId={match.params.orgId}
        show={newContextModalOpen}
        toggle={toggleContextModal}
      />
    </Fragment>
  )
}

OrgContainer.propTypes = {
  match: PropTypes.object,
}

export default OrgContainer
